<template>
  <div class="aboutus">
    <div class="aboutusBox tc">
      <img src="https://ef-imaster-file.oss-cn-beijing.aliyuncs.com/izt_static/PC/tangjiuhui/aboutus.png"/>
      <div class="aboutusBoxTop" v-if="false">
          <h4 class="aboutH4">{{$t('aboutus2.aboutusH4')}}</h4>
          <p class="aboutP">{{$t('aboutus2.aboutusP1')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP2')}}</p>
          <h4 class="aboutH4">{{$t('aboutus2.aboutusH4_1')}}</h4>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_1')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_2')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_3')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_4')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_5')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_6')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_7')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_8')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP1_9')}}</p>
          <p class="aboutP" style="padding-bottom:50px">{{$t('aboutus2.aboutusP1_10')}}</p>
          
          <!-- <p class="aboutP">{{$t('aboutus2.aboutusP3')}}</p>
          <p class="aboutP">{{$t('aboutus2.aboutusP4')}}</p> -->
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'Aboutus',
  computed: {},
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="stylus" scoped>
.aboutus{
  .aboutP3,
  .aboutP {
    text-indent 2em
  }
  .aboutusBoxTop{
    width $container-width-1200
    margin auto
  }
  .aboutusBox{
    margin 85px 0 0 0
    .aboutH4{
      text-align center
      color $color-main
      font-size 20px
      margin-bottom 38px;
    }
    .aboutP,.aboutP1,.aboutP2,.aboutP3{
      margin auto
      color $color-black-65
      font-size 16px
      margin-bottom 24px
    }
    .aboutP,.aboutP1{
    }
    .aboutP1{
      margin-top 40px;
    }
    .aboutP2{
      color $color-main
      font-size 18px
      margin-bottom 24px
    }
    .aboutusImg{
      width 100%
      margin-bottom 24px
    }
  }
  .aboutusBoxBot{
    width 100%
    background $color-white 
    padding 50px 0 
  }
}
</style>
